export default __webpack_public_path__ + "static/media/switch-down.0e92884a.svg";